// extracted by mini-css-extract-plugin
export default {"medium":"24px","text":"NotFoundPage_text__CXZ9O"};